/**
 * 404 Not Found Page
 * Displayed when user navigates to a non-existent route
 */

import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { FileQuestion, Home, ArrowLeft } from 'lucide-react';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40 p-4">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="flex flex-col items-center justify-center text-center py-8">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-muted mb-6">
              <FileQuestion className="h-10 w-10 text-muted-foreground" />
            </div>

            <h1 className="scroll-m-20 text-4xl/tight font-bold tracking-tight mb-2">
              404
            </h1>

            <h2 className="scroll-m-20 text-xl/snug font-semibold tracking-tight mb-4">
              Page Not Found
            </h2>

            <p className="text-sm/5 text-muted-foreground mb-6 max-w-sm">
              The page you're looking for doesn't exist or has been moved.
              Please check the URL or return to the dashboard.
            </p>

            <div className="flex flex-col gap-2 w-full sm:flex-row sm:justify-center">
              <Button onClick={() => navigate('/dashboard')} className="w-full sm:w-auto">
                <Home className="mr-2 h-4 w-4" />
                Go to Dashboard
              </Button>
              <Button
                onClick={() => navigate(-1)}
                variant="outline"
                className="w-full sm:w-auto"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Go Back
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
